import { theme, type ThemeConfig } from "antd";
import colors from "./colors";

export const antdThemeLight: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: colors.primary,
    // colorBorder: colors.slate[200],
    // colorPrimaryText: colors.slate[800],
    colorBgContainerDisabled: colors.primary,
    fontFamily: '"Noto Sans Bengali", "sans-serif"',
  },
  components: {
    Button: {
      borderRadius: 6,
      borderRadiusSM: 8,
      borderRadiusLG: 8,

      paddingInline: 15,
      controlHeight: 38,
      controlHeightLG: 48,
      controlHeightSM: 32,

      colorPrimaryBg: colors.primary,
      colorPrimaryActive: colors.primary,
      colorPrimaryBgHover: colors.primary,
      primaryShadow: "none",
    },
    Form: {
      verticalLabelMargin: "0px",
      verticalLabelPadding: "0px",
      // colorError: colors.error[500],
    },
    Input: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      // colorBorder: colors.gray[90],
      // hoverBorderColor: colors.gray[90],
      // colorBgContainer: colors.gray[98],
      // activeBorderColor: colors.gray[90],
      // colorErrorBorderHover: colors.error[500],

      colorText: colors.slate[800],
      // colorIcon: colors.gray[60],
      // colorError: colors.error[500],
      // colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[50],
      colorTextDisabled: colors.slate[600],
    },
    InputNumber: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      // colorBorder: colors.gray[90],
      // hoverBorderColor: colors.gray[90],
      // colorBgContainer: colors.gray[98],
      // activeBorderColor: colors.gray[90],
      // colorErrorBorderHover: colors.error[500],

      // colorIcon: colors.gray[60],
      // colorText: colors.slate[800],
      // colorError: colors.error[500],
      // colorTextDisabled: colors.slate[600],
      // colorTextPlaceholder: colors.slate[400],
      // colorBgContainerDisabled: colors.slate[25],
    },
    Select: {
      borderRadius: 6,
      borderRadiusSM: 8,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightXS: 32,
      controlHeightSM: 40,
      controlHeightLG: 46,
      fontSizeSM: 16,

      colorBorder: colors.slate[200],
      hoverBorderColor: colors.slate[200],
      activeBorderColor: colors.slate[200],
      colorErrorBorderHover: colors.error[500],
      colorBgContainer: "white",

      colorIcon: colors.slate[500],
      colorText: colors.slate[700],
      colorError: colors.error[500],
      optionSelectedBg: colors.gray[94],
      colorTextDisabled: colors.slate[600],
      colorTextPlaceholder: colors.slate[400],
      colorBgContainerDisabled: colors.slate[25],
    },
    DatePicker: {
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadius: 6,
      controlHeight: 38,
      borderRadiusLG: 8,
      controlHeightLG: 46,

      // colorBorder: colors.gray[90],
      // hoverBorderColor: colors.gray[90],
      // colorBgContainer: colors.gray[98],
      // activeBorderColor: colors.gray[90],
      // colorErrorBorderHover: colors.error[500],

      // colorIcon: colors.gray[60],
      // colorText: colors.slate[800],
      // colorError: colors.error[500],
      // colorTextDisabled: colors.slate[600],
      // colorTextPlaceholder: colors.slate[400],
      // colorBgContainerDisabled: colors.slate[25],
    },
    Checkbox: {
      // colorText: colors.slate[800],
      // colorBgContainerDisabled: colors.slate[25],
    },
    Badge: {
      lineWidth: 1.5,
    },
    Menu: {
      fontSize: 16,
      itemHeight: 38,
      itemMarginBlock: 4,
      itemBorderRadius: 8,
      itemMarginInline: 16,
      itemPaddingInline: 0,
      itemHoverBg: "transparent",
      // itemColor: colors.gray[500],
      // itemActiveBg: colors.gray[94],
      // itemHoverColor: colors.gray[2],
      // subMenuItemBg: colors.slate[25],
      // itemSelectedBg: colors.gray[94],
    },
    Layout: {
      bodyBg: "white",
      siderBg: "white",
      headerBg: "white",
    },
    Table: {
      padding: 12,
      fontSize: 14,
      borderRadiusLG: 0,
      colorBgContainer: "white",
      // colorText: colors.gray[24],
      // colorTextHeading: colors.gray[2],
      // colorBorderSecondary: colors.slate[200],
      headerBg: "transparent",
      rowHoverBg: "transparent",
      rowSelectedBg: "transparent",
      rowSelectedHoverBg: "transparent",
    },
    Pagination: {
      itemSize: 32,
      fontSize: 13,
      borderRadius: 4,
      // colorText: colors.gray[50],
      itemActiveBg: colors.primary,
    },
  },
};

export const antdThemeDark: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimaryText: "white",
    colorPrimary: colors.primary,
    // colorBorder: colors.gray[600],
    // colorPrimaryBg: colors.slate[900],
    // colorBgContainerDisabled: colors.slate[900],
  },
  components: {
    Button: {
      borderRadius: 6,
      borderRadiusSM: 8,
      borderRadiusLG: 8,

      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      paddingInline: 15,
      colorPrimaryBg: colors.primary,
      colorPrimaryActive: colors.primary,
      colorPrimaryBgHover: colors.primary,
      // colorBgContainerDisabled: colors.primaryDisabled,
    },
    Form: {
      verticalLabelMargin: 0,
      verticalLabelPadding: "0px",
      // colorError: colors.error[500],
    },
    Input: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 44,

      // colorBorder: colors.gray[600],
      // hoverBorderColor: colors.gray[600],
      // activeBorderColor: colors.gray[600],
      // colorBgContainer: colors.slate[900],
      // colorErrorBorderHover: colors.error[500],

      colorText: "white",
      colorIcon: "white",
      colorTextDisabled: "white",
      // colorError: colors.error[500],
      // colorTextPlaceholder: colors.slate[300],
      // colorBgContainerDisabled: colors.slate[800],
    },
    InputNumber: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      // colorBorder: colors.gray[600],
      // hoverBorderColor: colors.gray[600],
      // activeBorderColor: colors.gray[600],
      // colorBgContainer: colors.slate[900],
      // colorErrorBorderHover: colors.error[500],

      colorText: "white",
      colorIcon: "white",
      colorTextDisabled: "white",
      // colorError: colors.error[500],
      // colorTextPlaceholder: colors.slate[300],
      // colorBgContainerDisabled: colors.slate[800],
    },
    Select: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      // colorBorder: colors.gray[600],
      // hoverBorderColor: colors.gray[600],
      // activeBorderColor: colors.gray[600],
      // colorBgContainer: colors.slate[900],
      // colorErrorBorderHover: colors.error[500],

      colorText: "white",
      colorIcon: "white",
      colorTextDisabled: "white",
      // colorError: colors.error[500],
      // optionActiveBg: colors.slate[800],
      // colorBgElevated: colors.slate[900],
      // optionSelectedBg: colors.slate[800],
      // colorTextPlaceholder: colors.slate[300],
      // colorBgContainerDisabled: colors.slate[800],
      boxShadowSecondary:
        "0px 8px 24px rgba(0, 0, 0, 0.30), 0px 2px 8px rgba(0, 0, 0, 0.30)",
    },
    DatePicker: {
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: 38,
      controlHeightSM: 32,
      controlHeightLG: 46,

      // colorBorder: colors.gray[600],
      // hoverBorderColor: colors.gray[600],
      // activeBorderColor: colors.gray[600],
      // colorErrorBorderHover: colors.error[500],
      // colorBgContainer: colors.slate[900],

      colorText: "white",
      colorIcon: "white",
      colorTextDisabled: "white",
      // colorError: colors.error[500],
      // colorBgElevated: colors.slate[900],
      // colorTextPlaceholder: colors.slate[300],
      // colorBgContainerDisabled: colors.slate[800],
    },
    Checkbox: {
      // colorText: colors.slate[800],
      // colorBgContainerDisabled: colors.slate[25],
    },
    Badge: {
      lineWidth: 1.5,
    },
    Menu: {
      fontSize: 16,
      itemHeight: 38,
      itemMarginBlock: 4,
      itemBorderRadius: 8,
      itemMarginInline: 16,
      itemPaddingInline: 0,
      itemHoverBg: "transparent",
      // itemColor: colors.gray[500],
      // itemActiveBg: colors.gray[94],
      // itemHoverColor: colors.gray[2],
      // subMenuItemBg: colors.slate[25],
      // itemSelectedBg: colors.gray[94],
      // colorBgContainer: colors.slate[900],
    },
    Layout: {
      // bodyBg: colors.slate[900],
      // siderBg: colors.slate[900],
      // headerBg: colors.slate[900],
    },
    Table: {
      padding: 12,
      fontSize: 14,
      borderRadiusLG: 0,
      // colorBgContainer: colors.slate[800],
      colorBorderSecondary: "transparent",
      // colorBgLayout: colors.slate[900],
      colorText: "white",
      headerColor: "white",
      headerBg: "transparent",
      rowHoverBg: "transparent",
      rowSelectedBg: "transparent",
      rowSelectedHoverBg: "transparent",
      // borderColor: colors.gray[700],
    },
    Pagination: {
      fontSize: 13,
      itemSize: 32,
      borderRadius: 4,
      colorText: "white",
      itemActiveBg: colors.primary,
      // itemActiveBgDisabled: colors.slate[800],
    },
    Segmented: {
      // colorBgLayout: colors.slate[800],
      // colorBgElevated: colors.slate[900],
    },
    Dropdown: {
      // colorBgLayout: colors.slate[900],
      // colorBgElevated: colors.slate[800],
      // controlItemBgHover: colors.slate[900],
    },
  },
};
